import { useEffect, useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { listCompanies, type Company } from '../../api/companyApi.js';

export function CompanyListPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<readonly Company[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    listCompanies(token)
      .then((r) => { if (alive) setRows(r); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('companies.loading')}</p>;
  return (
    <main aria-label="company-list">
      <h1>{t('companies.title')}</h1>
      <Link to="/admin/companies/new" role="link">{t('companies.new')}</Link>
      <table aria-label="companies-table">
        <thead><tr><th>{t('companies.col.code')}</th><th>{t('companies.col.name')}</th><th>{t('companies.col.status')}</th><th>{t('companies.col.actions')}</th></tr></thead>
        <tbody>
          {rows.map((c) => (
            <tr key={c.id}>
              <td>{c.companyCode}</td>
              <td>{c.companyName}</td>
              <td>{c.status}</td>
              <td><Link to={`/admin/companies/${c.id}/edit`}>{t('companies.edit')}</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
